import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import T from 'prop-types';
// utils
import { setCurrentClassroom, getMissionProgress } from 'store/actions/classroom';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'store/actions/user';
import { setCookie, getCookie } from 'utils/cookie';
import { IS_DEVELOPMENT, IS_PRODUCTION, ROOT_URL } from 'config';

const Auth = ({ children }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { username, classrooms = [], isLoading: userLoading, hasErrors: userErrors } = useSelector(({ user }) => user);
  const {
    id: classId,
    currentMission: { id: missionId },
    isLoading: classroomLoading,
  } = useSelector(({ classroom }) => classroom);
  const authCookie = getCookie('user_token');

  useEffect(() => {
    if (IS_PRODUCTION && !authCookie) {
      window.location.href = ROOT_URL;
    }
  }, [authCookie]);

  useEffect(() => {
    // for development purposes, we set cookie manually
    // IS_DEVELOPMENT && !authCookie && setCookie('user_token', '121893ed-6e92-4991-b871-db5e5ae8f067');
    IS_DEVELOPMENT && !authCookie && setCookie('user_token', 'de0a0b13-a913-48ea-8cd8-49c777e42cb8');
    if (!username && !userLoading && !userErrors && authCookie) {
      dispatch(getUser()).catch((err) => {
        if (err.status === 401) {
          window.location.href = ROOT_URL;
        }
      });
    }
  }, [dispatch, pathname, username, userLoading, userErrors, authCookie]);

  // set default class on init
  useEffect(() => {
    if (!classId && classrooms.length > 0) {
      const lastClass = classrooms.find(({ id }) => +id === +localStorage.getItem('class-id'));
      dispatch(setCurrentClassroom(lastClass || classrooms[0]));
    }
  }, [classId, classrooms]);

  // get current mission progress
  useEffect(() => {
    if (!classroomLoading && !!classId && !!missionId) {
      dispatch(getMissionProgress(classId, missionId));
    }
  }, [classId, missionId]);

  return <>{children}</>;
};

Auth.propTypes = {
  children: T.oneOfType([T.func, T.string, T.node]),
};

export default Auth;
